import * as React from 'react';

function SvgAlertOctagon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M12.007 16c.825 0 1.493.672 1.493 1.5 0 .77-.576 1.403-1.318 1.49l-.19.01a1.496 1.496 0 01-1.492-1.5c0-.77.576-1.403 1.318-1.49l.19-.01zM12 5a1.419 1.419 0 011.417 1.498l-.362 6.504a1.057 1.057 0 01-2.11 0l-.362-6.504A1.419 1.419 0 0112 5z" />
      <path d="M16.14 1H7.86a1 1 0 00-.707.293l-5.86 5.86A1 1 0 001 7.86v8.28a1 1 0 00.293.707l5.86 5.86A1 1 0 007.86 23h8.28a1 1 0 00.707-.293l5.86-5.86A1 1 0 0023 16.14V7.86a1 1 0 00-.293-.707l-5.86-5.86A1 1 0 0016.14 1zm-.415 2L21 8.275v7.449L15.724 21H8.275L3 15.725V8.274L8.274 3h7.451z" />
    </svg>
  );
}

export default SvgAlertOctagon;
